import * as React from 'react';
import classNames from 'classnames';
import './Wrapper.scss';

export interface IProps {
  children?: any;
  className?: string;
  fullheight?: boolean;
}

const Wrapper = ({ children, className, fullheight }: IProps) => (
  <div 
    className={classNames(
      'wrapper',
      { 
        [`is-fullheight`]: fullheight 
      },
      className
    )}
  >
    {children}
  </div>
)

export default Wrapper


// WEBPACK FOOTER //
// ./src/components/Wrapper/index.tsx